<template>
  <div class="chat-header" title="Drag to move">
    <div class="flex-start">
      <div>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-label="ChatBubble"
        >
          <path
            class="text-color"
            d="M3 7.5H6v1.5H3a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h3v4.5l3.75-4.5h3.75a1.5 1.5 0 0 0 1.5-1.5h1.5a3 3 0 0 1-3 3h-3l-3.33 3.94c-.88 1.1-2.67.48-2.67-.94v-3H3a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3Z"
          />
          <path
            class="icon-link-color-hover"
            d="M21.37 9c-3.48 1.15-4.64 2.3-5.78 5.78-.1.29-.5.29-.6 0-1.14-3.47-2.3-4.63-5.78-5.78-.28-.1-.28-.5 0-.6 3.48-1.14 4.64-2.3 5.78-5.78.1-.28.5-.28.6 0 1.14 3.48 2.3 4.64 5.78 5.78.29.1.29.5 0 .6Z"
          />
          <path
            class="icon-link-color-hover"
            d="M23.89 3.3c-1.74.57-2.32 1.15-2.89 2.89-.05.14-.25.14-.3 0-.57-1.74-1.15-2.32-2.89-2.89-.14-.05-.14-.25 0-.3 1.74-.57 2.32-1.15 2.89-2.89.05-.14.25-.14.3 0 .57 1.74 1.15 2.32 2.89 2.89.14.05.14.25 0 .3Z"
          />
        </svg>
      </div>
      <div>
        <h3>Chat Assistant</h3>
        <p>Carbonite + Webroot support</p>
      </div>
    </div>
    <div>
      <button v-if="!chatBotStore.fullHeight" @click="chatBotStore.fullHeight = !chatBotStore.fullHeight">
        <img src="../svg/expand.svg" alt="Expand" />
      </button>
      <button v-else @click="chatBotStore.fullHeight = !chatBotStore.fullHeight">
        <img src="../svg/collapse.svg" alt="Collapse" />
      </button>
      <clear-history-btn />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useChatBotStore } from "../stores/chatBotStore";
const chatBotStore = useChatBotStore();

import ClearHistoryBtn from "./clearHistoryBtn.vue";
</script>
